export default "__VITE_ASSET__DRQr4FGS__"